require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/babel-loader/lib/index.js?{\"presets\":[\"/zeit/3ed6856d/node_modules/babel-preset-env/lib/index.js\",\"/zeit/3ed6856d/node_modules/babel-preset-react/lib/index.js\",\"/zeit/3ed6856d/node_modules/babel-preset-stage-0/lib/index.js\",[\"/zeit/3ed6856d/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/zeit/3ed6856d/node_modules/babel-preset-stage-0/lib/index.js\",\"/zeit/3ed6856d/node_modules/babel-preset-react/lib/index.js\"],\"plugins\":[\"/zeit/3ed6856d/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/zeit/3ed6856d/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/zeit/3ed6856d/node_modules/babel-plugin-transform-object-assign/lib/index.js\",\"syntax-dynamic-import\",\"dynamic-import-webpack\",\"transform-runtime\"],\"cacheDirectory\":true}!./PageTemplate.js") })
        }
      }, "component---src-templates-page-template-js");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=component---src-templates-page-template-js!./src/templates/PageTemplate.js
// module id = 577
// module chunks = 231608221292675